<template>
  <div
    :class="classLabel"
    class="flex items-center gap-1 label-type-answer text-xs rounded"
  >
    <aha-icon
      :name="icon"
      width="13"
      height="13"
      viewBox="0 0 18 18"
    >
    </aha-icon>
    <strong>{{ text }}</strong>
  </div>
</template>
<script>
const nameMaps = {
  incorrect: 'Incorrect',
  correct: 'Correct',
  partially_correct: 'Partially correct',
  not_submitted: 'not_submitted',
}

const classMap = {
  incorrect: 'incorrect-label',
  correct: 'correct-label',
  partially_correct: 'correct-label',
  not_submitted: 'unattempted-label',
}

const iconMap = {
  incorrect: 'incorrect',
  correct: 'correct',
  partially_correct: 'correct',
  not_submitted: 'warning',
}

export default {
  props: {
    typeAnswerCorrect: {
      type: String,
      default: 'correct',
    },
  },
  computed: {
    classLabel() {
      return classMap[this.typeAnswerCorrect]
    },
    text() {
      return nameMaps[this.typeAnswerCorrect]
    },
    icon() {
      return iconMap[this.typeAnswerCorrect]
    },
  },
}
</script>

<style scoped>
  .label-type-answer {
    padding : 4px 8px;
  }
  .correct-label {
    @apply bg-green-10 text-green-100;
  }
  .incorrect-label {
    @apply bg-red-10 text-red-100;
  }

  .unattempted-label {
    @apply bg-primary-50 text-secondary-100;
  }
</style>
